import React from 'react';
import { Box, Typography } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import { PASSWORD_RULES } from '../utils/passwordValidator';

interface PasswordPolicyChecklistProps {
  password: string;
}

/**
 * Live checklist that shows the password policy rules and ticks them off
 * as the user types. Used in every place that accepts a new password so
 * the rules are visible up-front instead of as a post-submit error.
 */
export default function PasswordPolicyChecklist({ password }: PasswordPolicyChecklistProps) {
  return (
    <Box sx={{ mt: 0.5, mb: 1, pl: 0.5 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.5, fontWeight: 500 }}
      >
        Password must contain:
      </Typography>
      {PASSWORD_RULES.map((rule) => {
        const passed = rule.test(password);
        return (
          <Box
            key={rule.id}
            sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.25 }}
          >
            {passed ? (
              <CheckCircle sx={{ fontSize: 16, color: 'success.main' }} />
            ) : (
              <RadioButtonUnchecked sx={{ fontSize: 16, color: 'text.disabled' }} />
            )}
            <Typography
              variant="caption"
              sx={{
                color: passed ? 'success.main' : 'text.secondary',
                fontWeight: passed ? 500 : 400,
              }}
            >
              {rule.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
